export var TypeActionSubscriptionInfo;
(function (TypeActionSubscriptionInfo) {
    TypeActionSubscriptionInfo["Update"] = "SubscriptionInfo > Update";
})(TypeActionSubscriptionInfo || (TypeActionSubscriptionInfo = {}));
export var actionSubscriptionInfoUpdate = function (subscriptionInfo) { return ({
    subscriptionInfo: subscriptionInfo,
    type: TypeActionSubscriptionInfo.Update,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/subscription/actionSubscriptionInfo.ts
// module id = 568
// module chunks = 3